import { useTranslation } from "react-i18next";

import { MainLayout } from "components/layouts";
import PayrollFrom from "./PayrollIncomeFrom";

import styles from "../styles/Income.module.css";
import { Breadcrumb, Flex, Space } from "antd";
import { useNavigate } from "react-router-dom";

const PayrollIncomeEdit = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <MainLayout>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("configuration.header"), href: "/configuration/payroll" },
            { title: t("payroll_setting.header"), href: "/configuration/payroll" },
            {
              title: t("income.header"),
              href: "/configuration/payroll",
              onClick: (e) => {
                e.preventDefault();
                navigate("/configuration/payroll", { state: { selectedTab: 'income' } });
              }
            },
            { title: t("common.edit") }
          ]} />
          <h2>{t("common.edit")}</h2>
        </Flex>
        <PayrollFrom {...props} />
      </Space>
    </MainLayout>
  );
};

export default PayrollIncomeEdit;
